export const buttonFocusRingClass = 'focus:outline-none focus:ring-0 focus-visible:ring-1 focus-visible:ring-zinc-500/80'

export const neutralButtonOnZincSurfaceClass = 'border border-zinc-700 bg-zinc-900 text-zinc-300 hover:border-zinc-600 hover:bg-zinc-800 hover:text-zinc-100'

export const activeButtonOnZincSurfaceClass = '!border-zinc-700 !bg-zinc-800 !text-zinc-50 hover:!border-zinc-600 hover:!bg-zinc-700 hover:!text-zinc-50'

export const neutralButtonOnBlackSurfaceClass = 'border border-[#33333a] bg-zinc-950 text-zinc-300 hover:border-zinc-600 hover:bg-zinc-900 hover:text-zinc-100'
export const activeButtonOnBlackSurfaceClass = '!border-[#33333a] !bg-zinc-900 !text-zinc-100 hover:!border-zinc-600 hover:!bg-zinc-800 hover:!text-zinc-50'

export const blackButtonSurfaceClass = 'border border-[#33333a] bg-zinc-950 text-zinc-100 hover:border-zinc-600 hover:bg-zinc-900 hover:text-zinc-50'

export const neutralButtonSurfaceClass = neutralButtonOnZincSurfaceClass
export const activeButtonSurfaceClass = activeButtonOnZincSurfaceClass
